import { useEffect, useState } from "react";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import { ANALYTICS_DATE_RANGES } from "../../../constants/buyerAnalyticsConstants";
import { fetchFunnelAnalytics } from "../../../services/automapBuyerAnalyticsApi";
import {
  AdminAnalyticsNav,
  AnalyticsRangeSelect,
  FunnelStepsTable,
} from "./AdminAnalyticsShared";

const FUNNEL_OPTIONS = [
  { value: "homepage_search", label: "Homepage / búsqueda" },
  { value: "seo", label: "SEO" },
  { value: "quiz", label: "Quiz" },
  { value: "vehicle_detail", label: "Detalle vehículo" },
];

export default function AdminFunnelAnalyticsPage() {
  const [range, setRange] = useState("last_30_days");
  const [funnel, setFunnel] = useState("homepage_search");
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    fetchFunnelAnalytics(funnel, range)
      .then(setPayload)
      .catch((err) => setError(err.message || "Error al cargar embudos."))
      .finally(() => setLoading(false));
  }, [funnel, range]);

  return (
    <AdminPageLayout>
      <AdminPageHeader
        eyebrow="AutoMapa · Analytics"
        title="Embudos de conversión"
        description="Conversión y abandono por flujo de comprador."
      />
      <AdminAutomotiveNav active="analytics" />
      <AdminAnalyticsNav active="funnels" />
      <main className="admin-console__main wrap">
        <div className="dealer-inventory-toolbar">
          <AnalyticsRangeSelect range={range} onChange={setRange} options={ANALYTICS_DATE_RANGES} />
          <label>
            Embudo
            <select value={funnel} onChange={(e) => setFunnel(e.target.value)}>
              {FUNNEL_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
        </div>
        {loading ? <p className="dealer-state-box">Cargando…</p> : null}
        {error ? <p className="dealer-state-box">{error}</p> : null}
        {!loading && !error ? <FunnelStepsTable steps={payload?.steps} /> : null}
      </main>
    </AdminPageLayout>
  );
}
